var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{staticClass:"iconsize",class:_vm.picposcls,attrs:{"src":"res/vr.png"},on:{"click":_vm.onClick}})}
var staticRenderFns = []

export { render, staticRenderFns }